import $ from 'jquery';
import slick from 'slick-carousel';

const siteContent = () => {
  $('.lk-widow-fix').each(function() {
    var wordArray = $(this).text().split(" ");
    if (wordArray.length > 1) {
      wordArray[wordArray.length-2] += "&nbsp;" + wordArray[wordArray.length-1];
      wordArray.pop();
      $(this).html(wordArray.join(" "));
    }
  });

  // $('.slider').each(function() {
  //   if (this) {
  //     console.log('slider');
  //     var $this = $(this);
  //     var autoplay = $this.data('slider-autoplay');
  //     var lazyMode = $this.data('slider-lazy');
  //     var autoplaySpeed = $this.data('slider-autoplay-speed');
  //
  //     $this.slick({
  //       dots: true,
  //       arrows: false,
  //       infinite: true,
  //       speed: 300,
  //       slidesToShow: 1,
  //       fade: true,
  //       cssEase: 'linear',
  //       autoplay: autoplay,
  //       lazyLoad: lazyMode,
  //       adaptiveHeight: false,
  //       autoplaySpeed: autoplaySpeed
  //     });
  //   }
  //   else {
  //     console.log('no slider');
  //   }
  // });
  //
  $('.slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    lazyLoad: false,
    adaptiveHeight: false,
    autoplaySpeed: 6000
  });
}

export default siteContent;
